import React, { lazy } from "react";
import { Switch } from "react-router-dom";
import asyncComponent from "../../util/asyncComponent";
import { useSelector } from "react-redux";
import { Redirect, Route } from "react-router-dom/cjs/react-router-dom.min.js";
const SubAdmins = lazy(() => import("./SubAdmins/index.js"));
const AddSubAdmins = lazy(() => import("./SubAdmins/AddSubAdmin/index.js"));
const EditSubAdmins = lazy(() => import("./SubAdmins/AddSubAdmin/index.js"));

const AddAgent = lazy(() => import("./Agent/EditAgent/index.js"));
const EditAgent = lazy(() => import("./Agent/EditAgent/index.js"));
const TabMaster = lazy(() => import("./TabMaster/index.js"));
const AddTabMaster = lazy(() => import("./TabMaster/AddTabMaster/index.js"));
const EditTabMaster = lazy(() => import("./TabMaster/AddTabMaster/index.js"));
const Role = lazy(() => import("./Roles/index.js"));
const AddRole = lazy(() => import("./Roles/AddRole/index.js"));
const EditRole = lazy(() => import("./Roles/AddRole/index.js"));
const AddWebsite = lazy(() => import("./websiteList/EditWebsite/index.js"));
const EditWebsite = lazy(() => import("./websiteList/EditWebsite/index.js"));
const AddVendor = lazy(() => import("./Vendor/AddVendor/index.js"));
const EditVendor = lazy(() => import("./Vendor/AddVendor/index.js"));
const Bank = lazy(() => import("./bank/index.js"));
const AddBank = lazy(() => import("./AddBankList/index.js"));
const EditBank = lazy(() => import("./AddBankList/index.js"));
const UserReport = lazy(() => import("./User/TransactionReport/index.js"));
const AddOperator = lazy(() => import("./Operator/AddOperator/index.js"));
const EditOperator = lazy(() => import("./Operator/AddOperator/index.js"));
const AddPaymentGetway = lazy(
  () => import("./PaymentGetway/AddPaymentGetway/index.js"),
);
const EditPaymentGetway = lazy(
  () => import("./PaymentGetway/AddPaymentGetway/index.js"),
);
const ErrorPage = lazy(() => import("./NoFound/index.js"));

const ProtectedRoute = ({ component: Component, permission, ...rest }) => {
  const { user } = useSelector((state) => state.auth);
  const hasPermission =
    permission === undefined ||
    user?.tabPermission?.some(
      (item) =>
        item.tabId?.tabUrl === permission && item.tabId?.isActive && item.view,
    );

  return (
    <Route
      {...rest}
      render={(props) =>
        hasPermission ? <Component {...props} /> : <Redirect to="/erropage" />
      }
    />
  );
};

const Admin = ({ match }) => (
  <div className="gx-main-content-wrapper">
    <Switch>
      <ProtectedRoute
        exact
        permission="dashboard"
        path={`${match.url}dashboard`}
        component={asyncComponent(() => import("./Dashboard/index.js"))}
      />

      <ProtectedRoute
        exact
        permission="sub-admins"
        path={`${match.url}sub-admins`}
        component={SubAdmins}
      />
      <ProtectedRoute
        exact
        permission="sub-admins"
        path={`${match.url}sub-admins/addSubAdmin`}
        component={AddSubAdmins}
      />
      <ProtectedRoute
        exact
        permission="sub-admins"
        path={`${match.url}sub-admins/editSubAdmin`}
        component={EditSubAdmins}
      />
      <ProtectedRoute
        exact
        permission="agents"
        path={`${match.url}agents`}
        component={asyncComponent(() => import("./Agent/index.js"))}
      />
      <ProtectedRoute
        exact
        permission="agents"
        path={`${match.url}agents/addagent`}
        component={AddAgent}
      />

      <ProtectedRoute
        exact
        permission="agents"
        path={`${match.url}agents/editagent`}
        component={EditAgent}
      />

      <ProtectedRoute
        exact
        permission="tabmaster"
        path={`${match.url}tabmaster`}
        component={TabMaster}
      />
      <ProtectedRoute
        exact
        permission="tabmaster"
        path={`${match.url}tabmaster/addtabmaster`}
        component={AddTabMaster}
      />
      <ProtectedRoute
        exact
        permission="tabmaster"
        path={`${match.url}tabmaster/edittabmaster`}
        component={EditTabMaster}
      />
      <ProtectedRoute
        exact
        permission="role"
        path={`${match.url}role`}
        component={Role}
      />
      <ProtectedRoute
        exact
        permission="role"
        path={`${match.url}role/addrole`}
        component={AddRole}
      />
      <ProtectedRoute
        exact
        permission="role"
        path={`${match.url}role/editrole`}
        component={EditRole}
      />
      <ProtectedRoute
        exact
        permission="website"
        path={`${match.url}website`}
        component={asyncComponent(() => import("./websiteList/index.js"))}
      />
      <ProtectedRoute
        exact
        permission="website"
        path={`${match.url}websites/editwebsite`}
        component={EditWebsite}
      />
      <ProtectedRoute
        exact
        permission="website"
        path={`${match.url}websites/addwebsite`}
        component={AddWebsite}
      />
      <Route
        exact
        permission="bank"
        path={`${match.url}bank`}
        component={Bank}
      />
      <Route
        exact
        permission="bank/account"
        path={`${match.url}bank/editbank`}
        component={EditBank}
      />
      <Route
        exact
        permission="bank/account"
        path={`${match.url}bank/addbank`}
        component={AddBank}
      />
      <ProtectedRoute
        exact
        permission="vendor"
        path={`${match.url}vendor`}
        component={asyncComponent(() => import("./Vendor/index.js"))}
      />
      <ProtectedRoute
        exact
        permission="vendor"
        path={`${match.url}vendor/addvendor`}
        component={AddVendor}
      />
      <ProtectedRoute
        exact
        permission="vendor"
        path={`${match.url}vendor/editvendor`}
        component={EditVendor}
      />
      <ProtectedRoute
        exact
        permission="operator"
        path={`${match.url}operator`}
        component={asyncComponent(() => import("./Operator/index"))}
      />
      <ProtectedRoute
        exact
        permission="operator"
        path={`${match.url}operator/addoperator`}
        component={AddOperator}
      />
      <ProtectedRoute
        exact
        path={`${match.url}operator/editoperator`}
        permission="operator"
        component={EditOperator}
      />

      <ProtectedRoute
        exact
        permission="deposit/queue"
        path={`${match.url}deposit/queue`}
        component={asyncComponent(() => import("./Deposit/index.js"))}
      />
      <ProtectedRoute
        exact
        permission="deposit-auto-queue"
        path={`${match.url}deposit-auto-queue`}
        component={asyncComponent(() => import("./Deposit/index.js"))}
      />
      <ProtectedRoute
        exact
        permission="withdraw/queue"
        path={`${match.url}withdraw/queue`}
        component={asyncComponent(() => import("./Withdraw/index.js"))}
      />
      <ProtectedRoute
        exact
        permission="withdraw-pending-report"
        path={`${match.url}withdraw-pending-report`}
        component={asyncComponent(() => import("./Withdraw/index.js"))}
      />

      <ProtectedRoute
        exact
        permission="setting"
        path={`${match.url}setting`}
        component={asyncComponent(() => import("./Settings/index.js"))}
      />
      <ProtectedRoute
        exact
        permission="deposit/report"
        path={`${match.url}deposit/report`}
        component={asyncComponent(() => import("./TransactionReport/index.js"))}
      />
      <ProtectedRoute
        exact
        permission="vendor/report"
        path={`${match.url}vendor/report`}
        component={asyncComponent(() => import("./VendorReport/index"))}
      />
      <ProtectedRoute
        exact
        permission="withdraw/report"
        path={`${match.url}withdraw/report`}
        component={asyncComponent(() => import("./WithdrawReport/index"))}
      />
      <ProtectedRoute
        exact
        permission="website-report"
        path={`${match.url}website-report`}
        component={asyncComponent(() => import("./WebsiteReport/index"))}
      />
      <ProtectedRoute
        exact
        permission="commission-summary"
        path={`${match.url}commission-summary`}
        component={asyncComponent(() => import("./Commission/index.js"))}
      />
      <ProtectedRoute
        exact
        permission="payment-gateway"
        path={`${match.url}payment-gateway`}
        component={asyncComponent(() => import("./PaymentGetway/index.js"))}
      />
      <ProtectedRoute
        exact
        permission="payment-gateway"
        path={`${match.url}payment-gateway/addpaymentgetway`}
        component={AddPaymentGetway}
      />
      <ProtectedRoute
        exact
        permission="payment-gateway"
        path={`${match.url}payment-gateway/editpaymentgetway`}
        component={EditPaymentGetway}
      />
      <ProtectedRoute
        exact
        permission="payment-gateway-report"
        path={`${match.url}payment-gateway-report`}
        component={asyncComponent(
          () => import("./PaymentGatewayReport/index.js"),
        )}
      />
      <ProtectedRoute
        exact
        permission="transaction-list"
        path={`${match.url}transaction-list`}
        component={asyncComponent(() => import("./TransactionList/index.js"))}
      />
      <ProtectedRoute
        exact
        permission="coins"
        path={`${match.url}coins`}
        component={asyncComponent(() => import("./Coins/index.js"))}
      />
      <ProtectedRoute
        exact
        permission="auto-coin-config"
        path={`${match.url}auto-coin-config`}
        component={asyncComponent(
          () => import("./Coins/AutoCoinConfig/index.js"),
        )}
      />
      <ProtectedRoute
        exact
        permission="coins"
        path={`${match.url}coins/add-coin-details`}
        component={asyncComponent(
          () => import("./Coins/AddCoinDetails/index.js"),
        )}
      />
      <ProtectedRoute
        exact
        permission="coins"
        path={`${match.url}coins/edit-coin-details`}
        component={asyncComponent(
          () => import("./Coins/AddCoinDetails/index.js"),
        )}
      />
      <ProtectedRoute
        exact
        permission="history"
        path={`${match.url}history`}
        component={asyncComponent(() => import("./History/index.js"))}
      />
      <ProtectedRoute
        exact
        permission="coins"
        path={`${match.url}coins/networks`}
        component={asyncComponent(() => import("./CoinNetworks/index.js"))}
      />
      <ProtectedRoute
        exact
        permission="deposit-verification-queue"
        path={`${match.url}deposit-verification-queue`}
        component={asyncComponent(() => import("./Deposit/index.js"))}
      />
      <ProtectedRoute
        exact
        permission="exchange-transactions"
        path={`${match.url}exchange-transactions`}
        component={asyncComponent(
          () => import("./ExchangeTransactions/index.js"),
        )}
      />
      <ProtectedRoute
        exact
        permission="history"
        path={`${match.url}history`}
        component={asyncComponent(() => import("./History/index.js"))}
      />
      <ProtectedRoute
        exact
        permission="transactions"
        path={`${match.url}transactions`}
        component={asyncComponent(
          () => import("./ExchangeTransactions/transactionCount.js"),
        )}
      />
      <ProtectedRoute
        exact
        permission="user"
        path={`${match.url}user`}
        component={asyncComponent(() => import("./User/index.js"))}
      />
      <ProtectedRoute
        exact
        permission="user"
        path={`${match.url}user/edituser`}
        component={asyncComponent(() => import("./User/EditUser/index.js"))}
      />
      <ProtectedRoute
        exact
        permission="user"
        path={`${match.url}user/transactionReport`}
        component={UserReport}
      />
      <ProtectedRoute
        path={`${match.url}commonpage`}
        exact
        permission="commonpage"
        component={asyncComponent(() => import("./CommonPage/index.js"))}
      />
      <ProtectedRoute
        path={`${match.url}login-entry`}
        exact
        permission="login-entry"
        component={asyncComponent(() => import("./LoginInfo/index.js"))}
      />
      <ProtectedRoute
        exact
        permission="error-log"
        path={`${match.url}error-log`}
        component={asyncComponent(
          () => import("./ErrorLog/index.js"),
        )}
      />
      <Route path={`${match.url}*`} exact component={ErrorPage} />
    </Switch>
  </div>
);

export default Admin;
